import { SAGA_REQUEST_KEY } from 'Constants';
import businessTypes from './types';

export const initialStates = {
	categories: [],
	list: null,
	businessList: [],
	rateAndReview: [],
	businessItem: [],
	commision: [],
	updated: null,
	contractLink: '',
	packages: [],
	sign: null,
	superBusiness: [],
	contractLinkComplete: null,
	businessInfoContract: null,
	businessRegister: null,
	cashierMachines: [],
	showOffcbReport: null,
	showCoreReport: null,
};

const businessReducers = (state = initialStates, action) => {
	switch (action.type) {
		case businessTypes.CONTRACT_BUSINESS_INFO.SUCCESS: {
			return {
				...state,
				businessInfoContract: action?.payload?.data?.attributes,
			};
		}

		case businessTypes.CONTRACT_BUSINESS_INFO.CLEAR: {
			return { ...state, businessInfoContract: null };
		}

		case businessTypes.CREATE_BUSINESS.SUCCESS: {
			return { ...state, businessRegister: action?.payload };
		}

		case businessTypes.CREATE_BUSINESS.CLEAR: {
			return { ...state, businessRegister: null };
		}

		case businessTypes.PACKAGES.SUCCESS: {
			return { ...state, packages: action?.payload?.data };
		}

		case businessTypes.PACKAGES.CLEAR: {
			return { ...state, packages: [] };
		}

		case businessTypes.CATEGORIES.SUCCESS: {
			return { ...state, categories: action?.payload?.data };
		}

		case businessTypes.CATEGORIES.CLEAR: {
			return { ...state, categories: [] };
		}

		case businessTypes.GET_BUSINESS.SUCCESS: {
			let key = 'list';
			key +=
				action?.payload?.requestAction?.[SAGA_REQUEST_KEY.LOADING_ID] || '';
			return {
				...state,
				[key]: action?.payload?.response?.data,
				showCoreReport:
					action?.payload?.response?.data?.attributes?.show_core_report,
				showOffcbReport:
					action?.payload?.response?.data?.attributes?.show_offcb_report,
			};
		}
		case businessTypes.GET_BUSINESS_List.SUCCESS: {
			return {
				...state,
				businessList: action?.payload?.response?.data,
			};
		}
		case businessTypes.GET_BUSINESS_List.CLEAR: {
			return {
				...state,
				businessList: [],
			};
		}
		case businessTypes.GET_BUSINESS.CLEAR: {
			const key = action?.payload?.key || 'list';
			return { ...state, [key]: null };
		}

		case businessTypes.RATEANDREVIEW.SUCCESS: {
			return { ...state, rateAndReview: action?.payload };
		}

		case businessTypes.BUSINESSITEM.SUCCESS: {
			return { ...state, businessItem: action?.payload };
		}

		case businessTypes.BUSINCOMMISION.SUCCESS: {
			return { ...state, commision: action?.payload };
		}

		case businessTypes.UPDATE.SUCCESS: {
			return { ...state, updated: action?.payload };
		}

		case businessTypes.UPDATE.CLEAR: {
			return { ...state, updated: null };
		}
		case businessTypes.CONTRACT_LINK.SUCCESS: {
			return {
				...state,
				contractLink: action?.payload?.link,
				contractLinkComplete: action?.payload,
			};
		}

		case businessTypes.CONTRACT_LINK.CLEAR: {
			return { ...state, contractLink: '', contractLinkComplete: '' };
		}

		case businessTypes.SIGN.SUCCESS: {
			return { ...state, sign: action?.payload };
		}

		case businessTypes.SIGN.CLEAR: {
			return { ...state, sign: '' };
		}

		case businessTypes.SUPER_BUSINESS.SUCCESS: {
			return { ...state, superBusiness: action?.payload };
		}

		case businessTypes.SUPER_BUSINESS.CLEAR: {
			return { ...state, superBusiness: [] };
		}

		case businessTypes.GET_CASHIER_MACHINES.SUCCESS: {
			return { ...state, cashierMachines: action?.payload };
		}

		case businessTypes.GET_CASHIER_MACHINES.FAILURE: {
			return { ...state, cashierMachines: [] };
		}

		default:
			return state;
	}
};

export default businessReducers;
